import { forwardRef, createElement } from 'react';

function IconGraphSolid(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm-.925 3.324a.75.75 0 00-.95.263l-.051.088-4.124 8.591-2.924-6.09-.057-.1a.751.751 0 00-1.238 0l-.057.1-1.724 3.59-.524-1.09-.05-.09a.75.75 0 00-1.34.644l.038.095 1.2 2.5.057.1a.751.751 0 001.238 0l.057-.1L9.6 11.233l2.924 6.092.057.1a.751.751 0 001.238 0l.057-.1 4.8-10 .038-.095a.75.75 0 00-.39-.906z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var GraphSolid = /*#__PURE__*/forwardRef(IconGraphSolid);

export default GraphSolid;
//# sourceMappingURL=GraphSolid.js.map
